import Main from "./Main";
const App = () => {
    return ( 
        <div className="min-h-full flex  justify-center  mt-1 lg:items-center">
            <Main />
        </div>
     );
}
 
export default App;